import SalePanelCollapse from './SalePanelCollapse'
import type { ObjectionItem } from './useSalePanels'
import { PanelText } from './styled-components'

interface ObjectionListProps {
  objections: ObjectionItem[]
}

const ObjectionList = ({ objections }: ObjectionListProps) => (
  <>
    {objections.map(objection => (
      <SalePanelCollapse
        key={objection.question}
        id={objection.id}
        compact
        last={objection.last}
        open={objection.open}
        onToggle={objection.onToggle}
        title={objection.title}
      >
        {objection.answers.map(answer => (
          <PanelText key={answer} dangerouslySetInnerHTML={{ __html: answer }} />
        ))}
      </SalePanelCollapse>
    ))}
  </>
)

export default ObjectionList
